import styled, { css } from 'styled-components/macro';
import { Link } from 'react-router-dom';

export const UserWrap = styled.div`
  @media (min-width: 992px) {
    padding: 0px;
  }
`;

export const CardHolder = css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 30px 15px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;
export const ProfileSection = styled.div`
  ${CardHolder}
`;
export const HeadingHolder = styled.div`
  text-align: center;
  margin: 0 0 25px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 20px;
  @media (min-width: 768px) {
    flex-direction: row;
  }
  h1 {
    margin-bottom: 0;
  }
`;

export const FormHolder = styled.div`
  width: 100%;
  max-width: 740px;
  margin: 0 auto;
  padding: 40px;
  box-sizing: border-box;
  border-radius: 20px;
  background: var(--bg-primary);
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  padding: 6px;
  border-radius: 30px;
  color: var(--primary-text-color);
  background: var(--light-secondary);

  .icon-chevron-right {
    font-size: 10px;
    line-height: 1;
  }
`;
